import { observer } from 'mobx-react-lite'
import { fromUnixTime, format } from 'date-fns'

import { useTheme } from '@mui/material/styles'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { CurrencyText, useGlobalCopyStore } from '../../common/'
import NetWorthChange from './NetWorthChange'
import { NetWorth } from '../../core/types/NetWorth'

interface NetWorthSummaryProps {
  hoveredData?: NetWorth
  selectedData: NetWorth
}

const NetWorthSummary: React.FC<NetWorthSummaryProps> = ({ hoveredData, selectedData }) => {
  const { net_worth: copy } = useGlobalCopyStore()
  const theme = useTheme()
  const summary = hoveredData ? hoveredData : selectedData

  const formattedMonth = format(fromUnixTime(summary.x), 'MMMM')

  return (
    <Stack alignItems="center" direction="column" m={24}>
      <Text color={theme.palette.secondary.main} variant="body2">
        {`${formattedMonth} ${copy.net_worth}`}
      </Text>
      <CurrencyText amount={summary.y} variant="h2" />
      <NetWorthChange currencyLabel={copy.this_month} netWorth={summary} theme={theme} />
    </Stack>
  )
}

export default observer(NetWorthSummary)
